import usePrivateLink from "../../config/usePrivateLink";
import React, { useState, useEffect } from "react";
import Header from "../../master/SideBar";
import Footer from "../footer";
import Nav from "../../master/NavBar";
import { getBatchList, viewlist } from "../../../api/BatchService";
import {
  StudentBatchList,
  studentsAttendance,
} from "../../../api/StudentsAttendance";
import { Link } from "react-router-dom";
import { getSessions } from "../../../api/SessionsService";
import { ToastMain, SweetAlertShow } from "../../master/Master";
import { map } from "jquery";
import DownloadExcel from "../../master/DownloadExcel";
import * as XLSX from "xlsx";
import AttendanceHeader from "./AttendanceHeader";
import { monthlyAttendance } from "../../../api/Staff";
import { printElement } from "../../master/Print";

const Attendancemonth = () => {
  const hasAccess = usePrivateLink();
  const [viewType, setViewType] = useState("day");
  const [totalDays, setTotalDays] = useState(0);
  const [selectedAttendance, setSelectedAttendance] = useState("present");
  const [activeTab, setActiveTab] = useState(null);
  const [batch, setBatch] = useState();
  const [error, setError] = useState();
  const [selectedBatchId, setSelectedBatchId] = useState("");
  const [students, setStudents] = useState([]);
  const [batchList, setBatchList] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState(""); // "YYYY-MM"
  const [data, setData] = useState([]);
  const [sessions, setSessions] = useState([]);
  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [loading, setLoading] = useState(false);
  const [selectedSession, setSelectedSessions] = useState("");

  const formatMonth = (monthStr) => {
    if (!monthStr) return "";
    const [year, month] = monthStr.split("-");
    const date = new Date(`${year}-${month}-01`);
    return date.toLocaleString("default", { month: "long", year: "numeric" });
  };
  const getMinMonth = () => {
    const now = new Date();
    now.setMonth(now.getMonth() - 5);
    return now.toISOString().slice(0, 7);
  };

  const batchliststudent = async (status = "") => {
    const addUrl = `&session_id=${selectedSession}`;
    setLoading(true);
    try {
      // console?.log("Fetching batches with status:", status); // ✅ Debugging log
      const response = await viewlist(addUrl);
      console?.log(
        "Batchlist response",
        response?.data?.batches?.[0]?.batch_fees
      );

      if (response?.data?.status) {
        setBatch(response?.data || []);
        console?.log("Batch fetched", response?.data?.batches);
      } else {
        setError("Failed to fetch batches?.");
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message
      );
    } finally {
      setLoading(false);
    }
  };

  const studentBatchFetch = async () => {
    setLoading(true);

    try {
      // console.log("Fetching Students with batch_id:",);
      const response = await StudentBatchList();

      if (response.data.success) {
        setBatchList(response.data || []);
        // console.log("Students batch list in attendance fetched", response.data);
      } else {
        setError("Failed to fetch students.");
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    studentBatchFetch();
    getSession();
  }, []);

  useEffect(() => {
    if (selectedSession) {
      batchliststudent();
    }
  }, [selectedSession]);

  const getSession = async () => {
    setLoading(true);

    try {
      const response = await getSessions(); // <-- your API call
      if (response.data.status) {
        const activeSession = response?.data?.data.find(
          (session) => session.status === "1"
        );
        setSelectedSessions(activeSession.id);
        setSessions(response?.data?.data);
      } else {
        setError("Failed to fetch session.");
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message
      );
    } finally {
      setLoading(false);
    }
  };

  const studentFetch = async () => {
    setLoading(true);

    let addUrl = `&batch_id=${selectedBatchId}&month=${selectedMonth}`;
    try {
      const response = await studentsAttendance(addUrl);

      if (response.data.status) {
        setStudents(response.data.data || []);
        console.log("Students fetched", response);
      } else {
        setError("Failed to fetch students.");
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (selectedBatchId && selectedMonth) {
      studentFetch();
    }
  }, [selectedBatchId, selectedMonth]);

  useEffect(() => {
    if (selectedMonth) {
      const [year, month] = selectedMonth.split("-").map(Number);
      setTotalDays(new Date(year, month, 0).getDate());
    }
  }, [selectedMonth]);
  useEffect(() => {
    const currentMonth = new Date().toISOString().slice(0, 7);
    setSelectedMonth(currentMonth);
  }, []);

  const handleDownload = () => {
    const exportData = [...students].reverse();

    if (!Array.isArray(exportData) || exportData.length === 0) {
      alert("No data available to export");
      return;
    }

    // 1️⃣ Data prepare
    const attendanceExport = exportData.map((student, index) => {
      const row = {
        SN: index + 1,
        "Registration No": student?.student_info?.registration_no || "N/A",
        Name: student?.student_info?.name || "N/A",
        Mobile: student?.student_info?.phone || "N/A",
      };

      for (let i = 1; i <= totalDays; i++) {
        const day = String(i).padStart(2, "0");
        const currentDate = `${selectedMonth}-${day}`;
        const att = student?.student_info?.attendance?.find(
          (a) => a.date === currentDate
        );

        const currentCheckDate = new Date(currentDate);
        const today = new Date();
        const isSunday = currentCheckDate.getDay() === 0;
        const isFuture = currentCheckDate > today;

        if (isSunday) {
          row[day] = "Sun";
        } else if (isFuture) {
          row[day] = "-";
        } else if (att) {
          row[day] = att.check_in === "1" ? "P" : "A";
        } else {
          row[day] = "";
        }
      }

      return row;
    });

    // 2️⃣ Headers
    const headers = [
      "SN",
      "Registration No",
      "Name",
      "Mobile",
      ...Array.from({ length: totalDays }, (_, i) => (i + 1).toString()),
    ];

    // 3️⃣ Convert to Excel format
    const worksheetData = [headers]; // first row = headers
    attendanceExport.forEach((row) => {
      const rowData = headers.map((header) => row[header] ?? "");
      worksheetData.push(rowData);
    });

    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);

    // 4️⃣ Workbook create
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Attendance");

    // 5️⃣ Save as file
    XLSX.writeFile(workbook, "Attendance_Report.xlsx");
  };
return (
    <>
      {loading && (
        <div
          className="d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100"
          style={{ zIndex: 9999 }}
        >
          <div className="sk-chase sk-primary display-1">
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
          </div>
        </div>
      )}
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-fluid mt-2">
                <div className="row custom-scroll-layout">
                  <div className="col-md-2 left-pane">
                    <AttendanceHeader data={"Attendance Portal"} />
                  </div>
                  <div className="col-md-10 right-pane">
                    <div className="card p-4 mb-4 shadow-sm ">
                      <div className="d-flex justify-content-between align-items-center flex-wrap mb-4">
                        <div className="d-flex gap-2 flex-wrap">
                          {hasAccess('/attendance_month/export') && (
                            <button
                              className="btn btn-success btn-sm"
                              onClick={handleDownload}
                              data-bs-toggle="tooltip"
                              data-bs-placement="top"
                              title="Export Excel"
                            >
                              <i className="bi bi-cloud-arrow-down ri-20px"></i>
                            </button>
                          )}
                        </div>
                      </div>
                      <div className="row ">
                        <div>
                          <div className="container-fluid p-3 ">
                            <div className=" mb-4">
                              <div className="  rounded-4 ">
                                <form>
                                  <div className="row g-3">
                                    <div className="col-md-3 form-floating form-floating-outline">
                                      <select
                                        className="form-select"
                                        value={selectedSession}
                                        onChange={(e) =>
                                          setSelectedSessions(e.target.value)
                                        }
                                      >
                                        {sessions?.map((session) => (
                                          <option
                                            key={session?.id}
                                            value={session?.id}
                                            selected={
                                              session?.status == "1" &&
                                              selectedSession?.status == "1" &&
                                              true
                                            }
                                          >
                                            {session?.session} :{" "}
                                            <span
                                              className={
                                                session?.status == "1"
                                                  ? "text-primary"
                                                  : "text-danger"
                                              }
                                            >
                                              {session?.status == "1"
                                                ? "Active"
                                                : "Inactive"}
                                            </span>
                                            {/* Show "2023-24" */}
                                          </option>
                                        ))}
                                      </select>

                                      <label>Filter Session</label>
                                    </div>

                                    <div className="col-md-3 form-floating form-floating-outline">
                                      <select
                                        className="form-control"
                                        onChange={(e) => {
                                          setSelectedBatchId(e?.target?.value); // ← Add this
                                        }}
                                        value={selectedBatchId}
                                        required
                                      >
                                        <option value="">Select Batch</option>
                                        {batch?.batches?.map((batch) => (
                                          <option
                                            key={batch?.id}
                                            value={batch?.id}
                                          >
                                            {batch?.title}
                                          </option>
                                        ))}
                                      </select>
                                      <label>Select Batch</label>
                                    </div>

                                    <div className="col-md-3 form-floating form-floating-outline">
                                      <input
                                        type="month"
                                        className="form-control"
                                        value={selectedMonth}
                                        onChange={(e) =>
                                          setSelectedMonth(e.target.value)
                                        }
                                        min={getMinMonth()}
                                        max={new Date()
                                          .toISOString()
                                          .slice(0, 7)}
                                      />

                                      <label> Select Month</label>
                                    </div>
                                  </div>
                                </form>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="card p-4 mb-4 ">
                      <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap mb-5">
                        <strong className="fw-bold fs-5">Students List</strong>
                        <div className="text-end">
                          <button
                            className="btn btn-sm btn-label-primary"
                            onClick={() => printElement("PrintDiv")}
                          >
                            Print
                          </button>
                        </div>
                      </div>

                      {/* Record Selector */}

                      {/* Table */}

                      <div className="table-responsive" id="PrintDiv">
                        <table className="table table-bordered attendance-table">
                          <thead>
                            <tr>
                              <th>#</th>
                              <th>Name(Reg.)</th>
                              {/* <th>Name</th> */}
                              {/* <th>Mobile</th> */}

                              {[...Array(totalDays)].map((_, i) => (
                                <th key={i}>{i + 1}</th>
                              ))}
                              <th>Summary</th>
                            </tr>
                          </thead>
                          <tbody>
                            {students.map((item, index) => (
                              <tr>
                                <td>{item?.student_info?.id}</td>

                                <td className="text-start">
                                  {item?.student_info?.name} (
                                  {item?.student_info?.registration_no})
                                </td>

                                {(() => {
                                  let totalP = 0;
                                  let totalA = 0;
                                  let totalWorkDays = 0;

                                  const cells = [...Array(totalDays)].map(
                                    (_, i) => {
                                      const day = String(i + 1).padStart(
                                        2,
                                        "0"
                                      );
                                      const currentDate = `${selectedMonth}-${day}`;

                                      const today = new Date();
                                      const currentCheckDate = new Date(
                                        currentDate
                                      );

                                      const isSunday =
                                        currentCheckDate.getDay() === 0;
                                      const isFuture = currentCheckDate > today;

                                      const attendance =
                                        item?.student_info?.attendance?.find(
                                          (att) => att.date === currentDate
                                        );

                                      let cellValue = "-";
                                      let cellClass = "";
                                      let inTime = "";
                                      let outTime = "";

                                      if (isSunday) {
                                        cellValue = "Sun";
                                        cellClass = "text-primary fw-bold";
                                      } else if (!isFuture) {
                                        totalWorkDays++;

                                        if (attendance) {
                                          if (
                                            attendance.check_in === "1"
                                          ) {
                                            inTime = attendance.check_in_time || "";
                                            outTime = attendance.check_out_time || "";

                                            cellValue = "P";
                                            cellClass = "text-success fw-bold";
                                            totalP++;
                                          } else if (
                                            attendance.check_in === "2"
                                          ) {
                                            cellValue = "A";
                                            cellClass = "text-danger fw-bold";
                                            totalA++;
                                          }
                                        } else {
                                          cellValue = "";
                                          cellClass = "text-danger fw-bold";
                                          totalA++;
                                        }
                                      }

                                      return (
                                        <td key={i} className={cellClass}>
                                          {cellValue === "P" ? (
                                            <>
                                              {cellValue}
                                              {inTime && (
                                                <div
                                                  style={{ fontSize: "9px" }}
                                                >
                                                  In: {inTime}
                                                </div>
                                              )}
                                              {outTime && (
                                                <div
                                                  style={{ fontSize: "9px" }}
                                                >
                                                  Out: {outTime}
                                                </div>
                                              )}
                                            </>
                                          ) : (
                                            <span>{cellValue}</span>
                                          )}
                                        </td>
                                      );
                                    }
                                  );

                                  return (
                                    <>
                                      {cells}
                                      <td>
                                        <div style={{ fontSize: "11px" }}>
                                          <div>
                                            <span className="text-success">
                                              P: {totalP}
                                            </span>
                                            /
                                            <span className="text-danger">
                                              A: {totalA}
                                            </span>
                                          </div>
                                          {/* <div>WD: {totalWorkDays}</div> */}
                                        </div>
                                      </td>
                                    </>
                                  );
                                })()}
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  \
                </div>
              </div>
            </div>
            <Footer />
            <div className="content-backdrop fade"></div>
          </div>
        </div>
        <div className="layout-overlay layout-menu-toggle"></div>
        <div className="drag-target"></div>
      </div>
    </>
  );
};

export default Attendancemonth;
